<script>
import MultipleSelector from '@/components/Form/MultipleSelector.vue';

export default {
  created() {
    this.options = [
      'H',
      'HV',
      'V',
      'P',
      'D',
      'DV',
      'HT',
      'HTV',
      'T',
      'G',
      'TV',
      'C',
      'X',
      'E',
    ];
  },
  extends: MultipleSelector,
  name: 'purchase-main-type-selector',
};
</script>
